// extracted by mini-css-extract-plugin
export default {"clueNumber":"ClueHeader_clueNumber__Hk3he","receivedDate":"ClueHeader_receivedDate__8af3E"};